"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CompareDailySpendNotificationSchema = exports.DailyBudgetRemainingNotificationSchema = exports.FundExhaustedNotificationSchema = exports.CompareDailySpendNotificationPayloadSchema = exports.DailyBudgetRemainingNotificationPayloadSchema = exports.FundExhaustedNotificationPayloadSchema = void 0;
const typebox_1 = require("@sinclair/typebox");
const core_1 = require("../../../core");
const ruby_1 = require("../../../ruby");
const BudgetNotificationPayloadFields = {
    campaignId: core_1.IdSchema,
    campaignName: core_1.NameSchema,
    teamId: core_1.IdSchema,
    teamName: core_1.NameSchema,
};
const DailyBudgetRemainingNotificationPayloadFields = {
    campaignId: core_1.IdSchema,
    campaignName: core_1.NameSchema,
    teamId: core_1.IdSchema,
    teamName: core_1.NameSchema,
    threshold: typebox_1.Type.Number(),
    thresholdString: typebox_1.Type.String(),
};
const CompareDailySpendNotificationPayloadFields = {
    campaignId: core_1.IdSchema,
    campaignName: core_1.NameSchema,
    teamId: core_1.IdSchema,
    teamName: core_1.NameSchema,
    percentage: typebox_1.Type.Number(),
    percentageString: typebox_1.Type.String(),
};
/**
 * Notification Payloads
 */
exports.FundExhaustedNotificationPayloadSchema = (0, core_1.StrictObject)(BudgetNotificationPayloadFields);
exports.DailyBudgetRemainingNotificationPayloadSchema = (0, core_1.StrictObject)(DailyBudgetRemainingNotificationPayloadFields);
exports.CompareDailySpendNotificationPayloadSchema = (0, core_1.StrictObject)(CompareDailySpendNotificationPayloadFields);
/**
 * Notification Types
 */
exports.FundExhaustedNotificationSchema = (0, ruby_1.createNotificationMessageSchema)(ruby_1.NotificationType.BUDGETS_FUND_EXHAUSTED, exports.FundExhaustedNotificationPayloadSchema);
exports.DailyBudgetRemainingNotificationSchema = (0, ruby_1.createNotificationMessageSchema)(ruby_1.NotificationType.DAILY_BUDGET_REMAINING, exports.DailyBudgetRemainingNotificationPayloadSchema);
exports.CompareDailySpendNotificationSchema = (0, ruby_1.createNotificationMessageSchema)(ruby_1.NotificationType.DAILY_SPEND_COMPARE, exports.CompareDailySpendNotificationPayloadSchema);
